<script setup>
import { useAuthStore } from '@/stores/Authentication'
import AuthProvider from '@/views/pages/authentication/AuthProvider.vue'
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import authV2LoginIllustrationBorderedDark from '@images/pages/auth-v2-login-illustration-bordered-dark.png'
import authV2LoginIllustrationBorderedLight from '@images/pages/auth-v2-login-illustration-bordered-light.png'
import authV2LoginIllustrationDark from '@images/pages/auth-v2-login-illustration-dark.png'
import authV2LoginIllustrationLight from '@images/pages/auth-v2-login-illustration-light.png'
import authV2MaskDark from '@images/pages/misc-mask-dark.png'
import authV2MaskLight from '@images/pages/misc-mask-light.png'
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'
import { getCurrentInstance } from 'vue'
import { VSwitch, VTextField } from 'vuetify/components'
import { useLocalizedValidators } from '@/composables/validators'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const { proxy } = getCurrentInstance() 

const form = ref({
  username: '',
  password: '',
  remember: false,
})

const errors = ref({
  username: undefined,
  password: undefined,
})
const { localizedRequired, localizedPassword } = useLocalizedValidators()

const isPasswordVisible = ref(false)

const authenticationStore = useAuthStore()
const route = useRoute()
const router = useRouter()
const ability = useAbility()

const authThemeImg = useGenerateImageVariant(authV2LoginIllustrationLight, authV2LoginIllustrationDark, authV2LoginIllustrationBorderedLight, authV2LoginIllustrationBorderedDark, true)
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)

const refVForm = ref()
const logining=ref(false)
const login = async () => {
  
  if(logining.value)
    return
  
  logining.value=true
  let authResult=await authenticationStore.login(form.value.username, form.value.password)
  logining.value=false

  console.log('authResult',authResult)
  if(authResult === true){
    await nextTick(() => {
      router.replace(route.query.to ? String(route.query.to) : '/')
    })
  }else if ( authResult===false ){
    errors.value.username = proxy.$t('Invalid username or password')
    errors.value.password = proxy.$t('Invalid username or password')
  }else {
    errors.value.username = proxy.$t('Connection Error')
    errors.value.password = proxy.$t('Connection Error')
  }
}

const onSubmit = () => {
  refVForm.value?.validate().then(({ valid: isValid }) => {
    if (isValid)
      login()
  })
}
</script>

<template>
  <a href="javascript:void(0)">
    <div class="auth-logo d-flex align-center gap-x-3">
      <VNodeRenderer :nodes="themeConfig.app.logo" />
      <h1 class="auth-title">
        {{ $t(themeConfig.app.title) }}
      </h1>
    </div>
  </a>

  <VRow
    no-gutters
    class="auth-wrapper bg-surface"
  >

    <VCol
      cols="12"
      md="8"
      class="auth-card-v2 d-flex align-center justify-center"
    >
      <VCard
        flat
        :max-width="500"
        class="mt-12 mt-sm-0 pa-6"
      >
        <VCardText>
          <h4 class="text-h4 mb-1">
            {{ $t('Welcome to Faradid Smart System') }} 👋🏻
          </h4>
          <p class="mb-0">
            {{ $t('Please sign-in to your account and start the adventure') }}
          </p>
        </VCardText>
        <VCardText>
          <VForm
            ref="refVForm"
            @submit.prevent="onSubmit"
          >
            <VRow>
              <!-- email -->
              <VCol cols="12">
                <AppTextField
                  v-model="form.username"
                  autofocus
                  :label="$t('Username')"
                  type="text"
                  placeholder="rahimisafari@gmail.com"
                  prepend-inner-icon="tabler-user"
                  :rules="[localizedRequired]"
                  :error-messages="errors.username"
                />
              </VCol>

              <!-- password -->
              <VCol cols="12">
                <AppTextField
                  v-model="form.password"
                  :label="$t('Password')"
                  placeholder="············"
                  :type="isPasswordVisible ? 'text' : 'password'"
                  autocomplete="password"
                  :append-inner-icon="isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'"
                  prepend-inner-icon="tabler-key"
                  :rules="[localizedRequired,localizedPassword]"
                  :error-messages="errors.password"
                  @click:append-inner="isPasswordVisible = !isPasswordVisible"
                />
                <div class="d-flex align-center flex-wrap justify-space-between my-6">
                  <RouterLink
                    class="text-primary ms-2 mb-1"
                    :to="{ name: 'forgot-password' }"
                  >
                    {{ $t('Forgot Password?') }}
                  </RouterLink>
                </div>

                <div class="d-flex align-center flex-wrap justify-space-between my-6">
                  <span class="me-2">{{ $t('Remember me') }}</span>
                  <VSwitch v-model="form.remember"/>
                  <!-- <RouterLink
                    class="text-primary ms-2 mb-1"
                    :to="{ name: 'forgot-password' }"
                  >
                    {{ $t('Forgot Password?') }}
                  </RouterLink> -->
                </div>

                <VBtn
                  block
                  type="submit"
                  class="rounded-lg"
                  @click="onSubmit"
                >
                  {{ $t('Login') }}
                </VBtn>
              </VCol>

              <!-- create account -->
              <!-- <VCol
                cols="12"
                class="text-body-1 text-center"
              >
                <span class="d-inline-block">
                  {{ $t('New on our platform?') }}
                </span>
                <RouterLink
                  class="text-primary ms-1"
                  :to="{ name: 'register' }"
                >
                  {{ $t('Create an account') }}
                </RouterLink>
              </VCol> -->

              <!-- <VCol
                cols="12"
                class="d-flex align-center"
              >
                <VDivider />
                <span class="mx-4">{{ $t('or') }}</span>
                <VDivider />
              </VCol> -->

              <!-- auth providers -->
              <!-- <VCol
                cols="12"
                class="text-center"
              >
                <AuthProvider />
              </VCol> -->
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </VCol>
    <VCol
      md="4"
      class="d-none d-md-flex"
    >
      <div class="position-relative bg-background w-100 me-0">
        <div
          class="d-flex align-center justify-center w-100 h-100"
        >
          <VImg
            max-width="613"
            :src="authThemeImg"
            class="auth-illustration mt-16 mb-2"
          />
        </div>

        <img
          class="auth-footer-mask flip-in-rtl"
          :src="authThemeMask"
          alt="auth-footer-mask"
          height="280"
          width="100"
        >
      </div>
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth";
</style>
